import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServiceDetailSection from './components/ServiceDetailSection';
import CtaSection from './components/CtaSection';
import ReviewsSection from './components/ReviewsSection';
import FaqSection from './components/FaqSection';
import BenefitsSection from './components/BenefitsSection';
import InsuranceConsultation from './components/InsuranceConsultation';
import KakaoChatBanner from './components/KakaoChatBanner';
import ContactFooter from './components/ContactFooter';

export default function HomePage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <ServiceDetailSection />
        <CtaSection />
        <ReviewsSection />
        <FaqSection />
        <BenefitsSection />
        <InsuranceConsultation />
        <KakaoChatBanner />
      </main>
      <ContactFooter />
    </div>
  );
}